import Table from "../../componentsTable/TanStackTable";
import {DataContext} from '../../../context/DataContext'
import {petitions} from '../../../api/calls'
import { useForm } from "react-hook-form";
import { useEffect, useState,useContext, useRef } from 'react'
import { toast } from "sonner";
import Swal from "sweetalert2";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";

function Medida() {
  const {session, idEmpresa } = useContext(DataContext);
  const [filtering, setFiltering] = useState("");
  const [medida, setMedida] = useState([])
  const [estado, setEstado] = useState(false)
  const [idMedida, setIdMedida] = useState('')
  const [load, setLoad] = useState(true)

  const modalRef = useRef(null)
  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  };

  const modalRef2 = useRef(null)

  const closeModal2 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
    modalInstance.hide();
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "idMedida",
    },
    {
      header: "UN/ECE",
      accessorKey: "simbolo",
    },
    {
      header: "Descripcion",
      accessorKey: "descripcion",
    },
    {
      header: "Medida",
      accessorKey: "medida",
    },
    {
      header: "Equivalencia",
      accessorKey: "equivalencia",
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-info"
              onClick={() => handleUpdate(row.original)}
            >
              Editar
            </button>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteMedida(row.original.idMedida)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    }
  ]

  const handleUpdate = (row) => {
    form2.setValue('simbolo', row.simbolo, { shouldValidate: true })
    form2.setValue('descripcion', row.descripcion, { shouldValidate: true })
    form2.setValue('medida', row.medida, { shouldValidate: true })
    form2.setValue('equivalencia', row.equivalencia, { shouldValidate: true })
    setIdMedida(row.idMedida)
    const modal = new window.bootstrap.Modal(modalRef2.current);
    modal.show();
  }

  const deleteMedida = (idMedida) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        text: "No podrás cancelar el proceso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await petitions.deleteMedida(idEmpresa(), session().token, {idMedida});
          if (response.status === "success") {
            if (response.data) {
              setEstado(!estado);
              toast.success("Medida eliminada correctamente"); 
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde");  
            }            
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
        }
      });
  }

  const form1 = useForm({defaultValues:{
    simbolo: "",
    descripcion: "",
    medida: 0.0,
    equivalencia: ""
  }});

  const form2 = useForm({defaultValues:{
    simbolo: "",
    descripcion: "",
    medida: 0.0,
    equivalencia: ""
  }})

  useEffect(() => {
    const fetchMedida = async () => {
      setLoad(true);
      const response = await petitions.getMedida(idEmpresa(), session().token);
      if (response.status === "success") {
        setMedida(response.data);
        setLoad(false);
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
        setLoad(false);
      }
    };

    fetchMedida();
  }, [estado, session, idEmpresa]);

  const sendMedida = form1.handleSubmit(async (data)=> {
    const response = await petitions.insertMedida(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        form1.reset();
        toast.success("Medida registrada correctamente")
        setEstado(!estado)
      }
      else{
        closeModal();
        toast.warning("Ocurrió un problema, inténtelo mas tarde")
      }
    } else {
      closeModal()
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const updateMedida = form2.handleSubmit(async (data) => {
    data.idMedida = idMedida
    const response = await petitions.updateMedida(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        closeModal2();
        form2.reset();
        toast.success("Medida actualizada correctamente")
        setEstado(!estado)
      }
      else{
        closeModal2();
        toast.warning("Ocurrió un problema, inténtelo mas tarde")
      }
    } else {
      closeModal2()
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  return (
    <>
      <div className="mb-9">
        <div className="row g-2 mb-4">
          <div className="col-auto">
            <h2 className="mb-0">Unidades de medida</h2>
          </div>
        </div>
        <div className="mb-4">
          <div className="row g-10">
            <div className="col-auto">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar medida"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
            </div>
            <div className="col-auto">
              <button className="btn btn-link text-body me-4 px-0" onClick={() => exportToExcel_v1(medida, columns, "Unidades de medida")}>
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <button
                className="btn btn-primary rounded-4"
                data-bs-toggle="modal"
                data-bs-target="#modalAgregarMedida"
              >
                <span className="fas fa-plus me-2"></span>Nueva medida
              </button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-responsive scrollbar-overlay mx-n1 px-1">
            {load ? (
                <TableLoad />
            ) : (
              <Table
                data={medida}
                columns={columns}
                filtering={filtering}
                setFiltering={setFiltering}
              />
            )}
          </div>
        </div>
      </div>

      {/* MODALS */}
      <div
        className="modal fade"
        id="modalAgregarMedida"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de medida
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendMedida}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    UN/ECE
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("simbolo", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio"
                      },
                      minLength:{
                        value: 1,
                        message: "Demasiado corto"
                      },
                      maxLength: {
                        value: 4,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.simbolo && (
                    <code>{form1.formState.errors.simbolo.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Descripción
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("descripcion", {
                      maxLength: {
                        value: 256,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.descripcion && (
                    <code>{form1.formState.errors.descripcion.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Medida
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="number"
                    step="any"
                    {...form1.register("medida", {
                    })}
                  />
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Equivalencia
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("equivalencia", {
                      maxLength: {
                        value: 5,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.equivalencia && (
                    <code>{form1.formState.errors.equivalencia.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Editar medida
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={updateMedida}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    UN/ECE
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("simbolo", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio"
                      },
                      minLength:{
                        value: 1,
                        message: "Demasiado corto"
                      },
                      maxLength: {
                        value: 4,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.simbolo && (
                    <code>{form2.formState.errors.simbolo.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Descripción
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("descripcion", {
                      maxLength: {
                        value: 256,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.descripcion && (
                    <code>{form2.formState.errors.descripcion.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Medida
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="number"
                    step="any"
                    {...form2.register("medida", {
                      valueAsNumber: {
                        value: true,
                        message: "debe ser numerico"
                      }
                    })}
                  />
                  {form2.formState.errors?.medida && (
                    <code>{form2.formState.errors.medida.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Equivalencia
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("equivalencia", {
                      maxLength: {
                        value: 5,
                        message: "Demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.equivalencia && (
                    <code>{form2.formState.errors.equivalencia.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Medida
